import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { usePrevious } from 'core/hooks/usePrevious';
import { triggerBonusBannerItemIsViewed } from '../actions';

export const useTriggerBonusHomeBannerGAEvents =
  (placementsToShow, activeBonusIndex, instanceType) => {
    const dispatch = useDispatch();
    const prevActiveBonusIndex = usePrevious(activeBonusIndex);

    useEffect(() => {
      const slideHasChanged = prevActiveBonusIndex !== undefined && prevActiveBonusIndex !== activeBonusIndex;
      if (!isEmpty(placementsToShow) || slideHasChanged) {
        dispatch(triggerBonusBannerItemIsViewed(placementsToShow[activeBonusIndex], instanceType));
      }
    }, [placementsToShow?.length, activeBonusIndex, instanceType]);
  };
